.price {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  transition: all 0.3s ease-in-out;
}

.primaryPrice {
  display: flex;
  align-items: baseline;
  gap: 0;
  font-size: var(--price-primary-font-size, var(--font-size-2xl));
  font-weight: var(--price-primary-font-weight, var(--font-weight-semi-bold));
  color: var(--price-primary-color, var(--color-primary));
}

.secondaryPrice {
  display: flex;
  align-items: baseline;
  gap: var(--price-secondary-gap, 2px);
  margin-top: var(--price-secondary-margin-top, 2px);
  font-size: var(--price-secondary-font-size, var(--font-size-md));
  font-weight: var(--price-secondary-font-weight, var(--font-weight-semi-bold));
  color: var(--price-secondary-color, var(--color-text-3));
}

.priceValue {
  display: inline-flex;
  align-items: baseline;
  gap: 2px;
}

.smallCurrencyCode {
  display: flex;
  align-items: baseline;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-bold);
  gap: 2px;
}

.suffixApproximate {
  font-size: var(--font-size-sm);
}
